const React = require('react')

import {
  Button,
  Col,
  Image,
  Modal,
  Row,
} from 'react-bootstrap'
const basePath = window.basePath || '';

export default class SiteTutorial extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      hideTutorial: false
    }
    this.handleClose = this.handleClose.bind(this)
    this.toggleHideTutorial = this.toggleHideTutorial.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({
        showModal: true
      })
    }
  }

  handleClose() {
    this.setState({
      showModal: false
    }, this.props.onClose(this.state.hideTutorial))
  }

  toggleHideTutorial() {
    this.setState({
      hideTutorial: !this.state.hideTutorial
    })
  }

  render() {

    return ( this.props.site ?
      <Modal show={this.state.showModal} onHide={this.handleClose}>
          <Modal.Header>
            <Modal.Title>
              Copying &quot;{this.props.site.title}&quot;
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={5} sm={5}>
                <Image
                  src={`${basePath}/img/boost-tutorial-1.png`}
                  width={200}
                />
              </Col>
              <Col md={6} sm={6}>
                <p>
                  <strong>&quot;{this.props.site.title}&quot;</strong> will now be copied to &quot;My Sites&quot; and will be automatically opened.
                </p>
                <p>
                  You will also be able to find this site under <br />
                  <strong>Sites</strong> &gt;&nbsp;
                  <strong>Academic</strong> &gt;&nbsp;
                  <strong>[Year]</strong> &gt;&nbsp;
                  <strong>[Subject]</strong> folders.
                </p>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Row>
              <Col md={4} mdOffset={6} sm={4} smOffset={6} xs={4} xsOffset={6}>
                <Button style={{border: 'none'}} onClick={this.toggleHideTutorial}>
                  <input type="checkbox" readOnly checked={this.state.hideTutorial}/>&nbsp; Don&apos;t show this again
                </Button>
              </Col>
              <Col md={2} xs={2} sm={2}>
                <Button
                  bsStyle='primary'
                  onClick={this.handleClose}>
                  OK
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>
      : null
    )
  }
}